import hydroscripts from '../assets/js/site.scripts.js'
import bootstrap from 'bootstrap'
import datepicker from 'bootstrap-datepicker'
import deepcopy from 'deepcopy'
import jmask from 'jquery-mask-plugin'

import tooltipster from 'tooltipster'
import FileSaver from 'file-saver'
import VueMask from 'v-mask'
import * as loader from '../components/loader/loader'
import * as tooltip from '../components/loader/tooltip'
import VersionSystem from '../components/VersionSystem/VersionSystem.vue'
import PasswordValidator from '../components/password-validator/PasswordValidator.vue'
import PersonalInfo from '../components/PersonalInfo/PersonalInfo.vue'
import MedicalInfo from '../components/MedicalConditions/medicals.vue'
import Jobdetails from '../components/Jobdetails/Jobdetails.vue'
import Icecontacts from '../components/ICEcontacts/Icecontacts.vue'
import NoPersonnelTabs from '../components/ICEcontacts/NoPersonnelTabs.vue' //zzzzzz FG - FOOF - After Cert - First Release Security(7)
import LocationPoolSelector from '../components/Location-Pool-Selector/Location-Pool-Selector.vue'
import ManagePersonnelCertifications from '../components/ManagePersonnelCertifications/ManagePersonnelCertifications.vue'
import Kudos from '../components/Kudos/Kudos.vue'
import Discipline from '../components/discipline/discipline.vue'
import Evaluation from '../components/Evaluation/Evaluation.vue'
import Checklist from '../components/checklist/checklist.vue'
import ChemicalChecklist from '../components/ChemicalChecklist/chemicalsettings.vue'
import ManageCertificates from '../components/Certificates/managecertificates.vue'
import ActivityCalender from '../components/ActivityCalender/calender.vue'
import TrainingCalender from '../components/TrainingCalender/calender.vue'
import NavigaionBar from '../components/NavigationBar/navigation_bar.vue'

import DashboardCalender from '../components/DashboardCalender/calender.vue'

import ChemicalRecord from '../components/ChemicalRecord/chemicalrecord.vue'
import ProfileDashboard from '../components/ProfileDashboard/profiledashboard.vue'
import Performance from '../components/Performance/Performance.vue'
import evals from '../components/EvaluationManage/EvaluationManage.vue'

import ReadingsMaintenance from '../components/ReadingsMaintenance/readings_maintenance.vue'

import HydrowareEditButton from '../widgets/hydroware-edit-button.vue' 
import HydrowareViewButton from '../widgets/hydroware-view-button.vue' 
import HydrowareCopyButton from '../widgets/hydroware-copy-button.vue'
import HydrowareDeleteButton from '../widgets/hydroware-delete-button.vue'
import HydrowareInlineInput from '../widgets/hydroware-inline-input.vue'
import HydrowareContainerWithHeading from '../widgets/hydroware-container-with-heading.vue'
import HydrowareCheckboxGroup from '../widgets/hydroware-checkbox-group.vue'
import HydrowareSuccessFailureButtons from '../widgets/hydroware-success-failure-buttons.vue'
import HydrowareAddButton from '../widgets/hydroware-add-button.vue'
import HydrowareOtherInputPlaceholder from '../widgets/hydroware-other-input-placeholder.vue'

//FG - FOOF - After Cert - First Release (7) - First Release Security (added template to display when a user doesn't have rights to even display a page)
import HydrowareAccessToPageDenied from '../page_substitutes/hydroware-access-to-page-denied.vue'
import HydrowareViewOrEditButton from '../widgets/hydroware-viewOrEdit-button.vue' //FG - FOOF - After Cert - First Release (7) - also while writing security code

import CustomReadings from '../components/CustomReadings/custom_readings.vue'
import CustomMaintenance from '../components/CustomMaintenance/custom_maintenance.vue'
import CustomTasks from '../components/CustomTasks/custom_tasks.vue'

import Transfer from '../components/transfer/transfer.vue'
import AddCertificates from '../components/Certificates/addcertificates.vue'
// import { VueTreeList, Tree, TreeNode } from '../src'
import FullCalendar from 'vue-full-calendar'
import sortablejs from 'sortablejs'

import VueFormWizard from 'vue-form-wizard'
import trumbowyg from 'vue-trumbowyg'
import '!style-loader!css-loader!vue-form-wizard/dist/vue-form-wizard.min.css'
import '!style-loader!css-loader!fullcalendar/dist/fullcalendar.css'
import '!style-loader!css-loader!vue-wysiwyg/dist/vueWysiwyg.css'
import '!style-loader!css-loader!trumbowyg/dist/ui/trumbowyg.css'

//FG - FOOF - Feb 7 2019 import the js file that contains global mixins
import hydrowareCommonMixins from '../hydrowareCommonMixins'



import Vue from 'vue'

//FG - FOOF - Feb 7 2019 Register the hydroware global mixins
Vue.mixin(hydrowareCommonMixins); 

//FG - FOOF - May 30 2019 - moved code below from main.js
import hydrowareCommonJS from '../hydrowareCommonJS'
const hydrowareCommonJSPlugin = {
  install () {
      Vue.hydrowareCommonJS = hydrowareCommonJS
      Vue.prototype.$hydrowareCommonJS = hydrowareCommonJS
  }
} 
//FG - FOOF - HYDROWARE PLUGIN
Vue.use(hydrowareCommonJSPlugin)
//FG - FOOF - May 30 2019 - moved code above from main.js

/********************************************************************************************
 * FG - FOOF - After Cert - First Release (7) - First Release Security
 * I created the hydrowareSecurityJS.js file to do the security checks for the first release
 * --It is imported and vue is told to use it - BELOW
 * *****************************************************************************************/
import hydrowareSecurityJS from '../hydrowareSecurityJS'
const hydrowareSecurityJSPlugin = {
  install () {
      Vue.hydrowareSecurityJS = hydrowareSecurityJS
      Vue.prototype.$hydrowareSecurityJS = hydrowareSecurityJS
  }
} 
Vue.use(hydrowareSecurityJSPlugin)
/* FG - FOOF - After Cert - First Release (7) - First Release Security - ABOVE
******************************************************************************************/

Vue.use(VueFormWizard)
Vue.use(FullCalendar)
// Vue.component('VueTreeList',VueTreeList)
Vue.component('evalmanage', evals)
Vue.component('wisi', trumbowyg)
Vue.component('readings-maintenance', ReadingsMaintenance)

Vue.component('hydroware-edit-button', HydrowareEditButton)
Vue.component('hydroware-view-button', HydrowareViewButton)
Vue.component('hydroware-copy-button', HydrowareCopyButton)
Vue.component('hydroware-delete-button', HydrowareDeleteButton)
Vue.component('hydroware-inline-input', HydrowareInlineInput)
Vue.component('hydroware-container-with-heading', HydrowareContainerWithHeading)
Vue.component('hydroware-checkbox-group', HydrowareCheckboxGroup)
Vue.component('hydroware-success-failure-buttons', HydrowareSuccessFailureButtons)
Vue.component('hydroware-add-button', HydrowareAddButton)
Vue.component('hydroware-other-input-placeholder', HydrowareOtherInputPlaceholder)

//FG - FOOF - After Cert - First Release (7) - First Release Security (added template to display when a user doesn't have rights to even display a page)
Vue.component('hydroware-access-to-page-denied', HydrowareAccessToPageDenied)
Vue.component('hydroware-viewOrEdit-button', HydrowareViewOrEditButton) //FG - FOOF - After Cert - First Release (7) - also while writing security code

Vue.component('custom-readings', CustomReadings)
Vue.component('custom-maintenance', CustomMaintenance)
Vue.component('custom-tasks', CustomTasks)

Vue.component('transfer', Transfer)
Vue.component('NavigaionBar', NavigaionBar)
Vue.component('Performance', Performance)
Vue.component('ActivityCalender', ActivityCalender)
Vue.component('TrainingCalender', TrainingCalender)
Vue.component('DashboardCalender', DashboardCalender)
Vue.component('version', VersionSystem)
Vue.component('PasswordValidator', PasswordValidator)
Vue.component('Personal-Info', PersonalInfo)
Vue.component('Job-Details', Jobdetails)
Vue.component('Ice-Contacts', Icecontacts)
Vue.component('NoPersonnel-Tabs', NoPersonnelTabs) //FG - FOOF - After Cert - First Release Security(7)
Vue.component('location-pool-selector', LocationPoolSelector)
Vue.component('Manage-Personnel-Certifications', ManagePersonnelCertifications)
Vue.component('Discipline', Discipline)
Vue.component('Evaluation', Evaluation)
Vue.component('Kudos', Kudos)
Vue.component('Checklist', Checklist)

//FOOF - zzzzz - below ---- NOT USED ???
//Vue.component('Chemicals', Chemicals)
//FOOF - zzzzz - below ---- NOT USED ???

Vue.component('ChemicalRecord', ChemicalRecord)
Vue.component('MedicalInfo', MedicalInfo)
Vue.component('ProfileDashboard', ProfileDashboard)
Vue.component('AddCertificates', AddCertificates)
Vue.component('ChemicalChecklist', ChemicalChecklist)
Vue.component('ManageCertificates', ManageCertificates)
Vue.use(VueMask)

window.FileSaver = FileSaver
window.mask = jmask
window.tooltipster = tooltipster
window.sortablejs = sortablejs

Vue.directive('mask', VueMask.VueMaskDirective)

/*FG - FOOF - hydromask directive was added - May 29 2019
  -- v-mask="'###-##-####'" DID NOT WORK for el-input
  -- So I created a custom directive "v-hydromask"
  -- it uses the masks from the jquery mask plugin
  -- https://igorescobar.github.io/jQuery-Mask-Plugin/docs.html
  -- NOTE: you can find an example of this in PersonalInfo.vue
  -- This is a custom directive*/
Vue.directive('hydromask', {
  //inserted: function (el, binding) {
  //    var inputEls = $(el).find('input');
  //    for(var i=0;i<inputEls.length;i++) {
  //      $(inputEls[i]).mask(binding.value)
  //    }
  //}
  inserted: function (el,binding) {
    hydrowareCommonJS.maskValue(el, binding.value)
  }
})


window.loader = loader
window.tooltip = tooltip
window.deepcopy = deepcopy

EnableConsoleLogs(false)

function EnableConsoleLogs(status) {

  var DEBUG = status

  if (!DEBUG) {
    console.log = function () {}
    window.console = console
  }

  Vue.config.debug = status
  if (status == false) {
    Vue.config.silent = true
  } else {
    Vue.config.silent = false
  }

}

$(function () {


  $('.el-icon-edit').parent().css('background-color', 'blue !important');







  /*  $('label').bind('mouseenter', function () {
      var $this = $(this)

      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text())
      }
    })

    $('.el-table__body,.VueTables__table').on('mouseenter', 'td', function () {
      var $this = $(this)

      if (this.offsetWidth <= this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text())
      }
    })*/

  $('.VueTables__search input').keyup(function () {

    var x = $(this).val()

    if (x.trim() == '') {

      $(this).val(x.replace(/^\s+|\s+$/g, ''))
    }

  })

  /*  $('td').bind('mouseenter', function(){
   var $this = $(this)
   alert("sd")
   if(this.offsetWidth < this.scrollWidth && !$this.attr('title')){
   $this.attr('title', $this.text());
   }
   });*/

})



// WEBPACK FOOTER //
// ./src/loader_modules/js_loader.js